<template>
    <div>
        <SiteHeader style="width: 100%;"></SiteHeader>
        <NavbarStatic style="width: 100%"></NavbarStatic>
        <div style="margin-top: 50px;">
            <div class="container" style="background-color: rgba(246, 246, 246, 0.80); padding-bottom: 50px;">
                <br>
                <center>
                    <h1 style="font-family: Arial; color: #012376;"><strong>SCHEDULE OF FEES</strong></h1>
                </center>
                <br>
                <el-collapse>
                    <el-collapse-item name="1" style="background-color: #012376; text-color: #ffffff">
                        <template slot="title">
                            <strong style="font-family: Arial;">&nbsp;&nbsp;&nbsp;GRADE SCHOOL SCHEDULE OF FEES AND PAYMENT SCHEME SY 2024-2025</strong>
                        </template>
                        <div>&nbsp;</div>
                        <div>
                            <iframe :src="env_wp.APP_URL+'/public/assets/pdf/admission/Payment_Scheme_GS.pdf'" frameborder="1" style="width: 200%; height: 700px;"></iframe>
                        </div>
                    </el-collapse-item>
                    <br>
                    <el-collapse-item name="2" style="background-color: #012376; text-color: #ffffff">
                        <template slot="title">
                            <strong style="font-family: Arial;">&nbsp;&nbsp;&nbsp;JUNIOR HIGH SCHOOL SCHEDULE OF FEES AND PAYMENT SCHEME SY 2024-2025</strong>
                        </template>
                        <div>&nbsp;</div>
                        <div>
                            <iframe :src="env_wp.APP_URL+'/public/assets/pdf/admission/Payment_Scheme_JHS.pdf'" frameborder="1" style="width: 200%; height: 700px;"></iframe>
                        </div>
                    </el-collapse-item>
                    <br>
                    <el-collapse-item name="3" style="background-color: #012376; text-color: #ffffff">
                        <template slot="title">
                            <strong style="font-family: Arial;">&nbsp;&nbsp;&nbsp;SENIOR HIGH SCHOOL SCHEDULE OF FEES AND PAYMENT SCHEME SY 2024-2025</strong>
                        </template>
                        <div>&nbsp;</div>
                        <div>
                            <iframe :src="env_wp.APP_URL+'/public/assets/pdf/admission/Payment_Scheme_SHS.pdf'" frameborder="1" style="width: 200%; height: 700px;"></iframe>
                        </div>
                    </el-collapse-item>
                    <br>
                    <el-collapse-item name="4" style="background-color: #012376; text-color: #ffffff">
                        <template slot="title">
                            <strong style="font-family: Arial;">&nbsp;&nbsp;&nbsp;COLLEGE SCHEDULE OF FEES SY 2024-2025</strong>
                        </template>
                        <div>&nbsp;</div>
                        <div>
                            <iframe :src="env_wp.APP_URL+'/public/assets/pdf/admission/College_Schedule_of_Fees_SY24_25.pdf'" frameborder="1" style="width: 200%; height: 700px;"></iframe>
                        </div>
                    </el-collapse-item>
                    <br>
                    <el-collapse-item name="5" style="background-color: #012376; text-color: #ffffff">
                        <template slot="title">
                            <strong style="font-family: Arial;">&nbsp;&nbsp;&nbsp;GRADUATE SCHOOL SCHEDULE OF FEES SY 2024-2025</strong>
                        </template>
                        <div>&nbsp;</div>
                        <div>
                            <iframe :src="env_wp.APP_URL+'/public/assets/pdf/admission/Graduate_School_Schedule_of_Fees_SY24_25.pdf'" frameborder="1" style="width: 200%; height: 700px;"></iframe>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>

        <div style="margin-top: 20px; margin-bottom: 20px;">
            <div class="row" :style="!isWindowOnDesktop ? 'margin-left: 0; margin-right: 0;' : ''">
                <div :class="!isWindowOnDesktop ? 'col-md-2' : 'col-md-6'" style="padding-right: 0px;">
                    &nbsp;
                </div>
                <div :class="!isWindowOnDesktop ? 'col-md-2' : 'col-md-6'" :style="!isWindowOnDesktop ? 'padding-right: 0px;' : ''">
                    <button @click="scrollToTop()" class="btn btn-ssa pull-right"><span style="font-family: Arial; font-size: 2rem; color: #ffffff;"><strong><i class="fa fa-angle-double-up" aria-hidden="true"></i>Back to Top</strong></span></button>
                </div>
            </div>
        </div>

        <div style="margin-top: 75px;">
            &nbsp;
        </div>
        <SiteFooter :style="{backgroundImage: `url('${env_wp.APP_URL}/public/assets/img/ssa_manila/hompage/footer_assets/comp/footer_backdrop.png')`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', position: 'relative', width: '100%', paddingRight: 0}"></SiteFooter>
    </div>
</template>
<style>
    .el-collapse-item__header{
        display: flex;
        align-items: center;
        height: 48px;
        line-height: 48px;
        background-color: #012376;
        color: #ffffff;
        cursor: pointer;
        border-bottom: 1px solid #EBEEF5;
        font-size: 13px;
        font-weight: 500;
        transition: border-bottom-color .3s;
        outline: 0;
    }
    .el-collapse-item__content {
        padding-bottom: 25px;
        font-size: 13px;
        color: #303133;
        line-height: 1.769230769230769;
        margin-left: 25px;
    }
</style>
<script>
    import SiteHeader from "../../../../components/general/SiteHeader";
    import NavbarStatic from "../../../../components/general//NavbarStatic";
    import SiteFooter from "../../../../components/general/SiteFooter";
    export default {
        props: {
            resources: Array
        },
        components: { SiteHeader, NavbarStatic, SiteFooter },
        data () {
            return {
                folder_name: this.$root.folder_name,
                env_wp: this.$root.env_wp.env_wp,
                screenWidth: 0,
                isWindowOnDesktop: true,
            }
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize)
            });
            this.onResize();
        },
        created() {
            this.addSsaColorClass();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        watch: {
            screenWidth(width) {
                if (width > 768) {
                    this.isWindowOnDesktop = true;
                    //this.css = 'mt-3 px-5';
                } else {
                    this.isWindowOnDesktop = false;
                    //this.css = 'mt-3 px-3';
                }
            },
        },
        methods: {
            scrollToTop(){
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            },
            addSsaColorClass(){
                $(".el-collapse-item__header").css({
                    "background-color": "#012376",
                    "color": "#ffffff"
                });
            },
            onResize(event) {
                this.screenWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            },
        }
    }
</script>
